module.exports = __webpack_public_path__ + "fonts/Poppins-300-latin6.39576fe.woff2";